export enum ActionTypes {
  RECEIVE_REGION_HOME_DATA = 'RECEIVE_REGION_HOME_DATA',
  RECEIVE_REGION_CARBON_TREND_DATA = 'RECEIVE_REGION_CARBON_TREND_DATA',
  RECEIVE_REGION_HOURLY_CARBON_TREND_DATA = 'RECEIVE_REGION_HOURLY_CARBON_TREND_DATA',
  RECEIVE_REGION_FUELMIX_TREND_DATA = 'RECEIVE_REGION_FUELMIX_TREND_DATA',
  RECEIVE_REGION_HOURLY_FUELMIX_TREND_DATA = 'RECEIVE_REGION_HOURLY_FUELMIX_TREND_DATA',
  RECEIVE_EIA_US_MAP = 'RECEIVE_EIA_US_MAP',
  RECEIVE_MAP_STATUS = 'RECEIVE_MAP_STATUS',
};
